import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { DeliveryActions } from './delivery.actions';
import { IDeliveryState } from './delivery.state';

export const initialDeliveryState: IDeliveryState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const deliveryReducerFn = createReducer(
  initialDeliveryState,
  on(DeliveryActions.reset, (state: IDeliveryState, action) => {
    return new StateBuilder<IDeliveryState>(initialDeliveryState).build();
  }),
  on(DeliveryActions.load, (state: IDeliveryState, action) => {
    return new StateBuilder<IDeliveryState>(state).toLoading().build();
  }),
  on(DeliveryActions.loadTimeTable, (state: IDeliveryState, action) => {
    return new StateBuilder<IDeliveryState>(state).toLoading().build();
  }),
  on(DeliveryActions.loadSuccess, (state: IDeliveryState, action) => {
    return new StateBuilder<IDeliveryState>(state, action).toLoaded().build();
  }),
  on(DeliveryActions.loadTimeTableSuccess, (state: IDeliveryState, action) => {

    const newState = new StateBuilder<IDeliveryState>(state, {
      model: { ...state.model, ...action.model },
      data: { 
        ...state.data, 
        ...{
          ...action.data,
          ...{
            deliveryTimetable: action.data.deliveryTimetable,
            formsKitDelivery: action.data.formsKitDelivery
          }
        }
      } 
    })
      .toLoaded()
      .build();

    return { ...newState };
  }),
  on(DeliveryActions.submit, (state: IDeliveryState, action) => {
    return new StateBuilder<IDeliveryState>(state).toLoading().build();
  }),
  on(DeliveryActions.submitSuccess, (state: IDeliveryState, action) => {
    return new StateBuilder<IDeliveryState>(state, action).toLoaded().build();
  })
);

export function deliveryReducer(state: IDeliveryState | undefined, action: Action) {
  return deliveryReducerFn(state, action);
}
